// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================ OPTION TOGGLE ============================== */
.opt-toggle-tag-container {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
}

.opt-toggle-selected-type-display {
  display: flex;
  justify-content: flex-start;
  font-size: 0.8rem;
}

.opt-toggle-tags {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
}

.opt-toggle-tag-selected {
  display: flex;  
  justify-content: center;
  border-radius: 4px;
  padding: 0 8px 0 8px;
  min-width: 20px;
  max-width: 60px;
  height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  align-items: center;
  font-size: 0.9em;
}

.opt-toggle-tags-sep {
  min-width: 2px;
  margin: 3px 2px;
  border-radius: 4px;
}

.opt-toggle-tag-text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.opt-toggle-container {
  display: flex;
  height: 55px;
  gap: 12px;
  filter: drop-shadow(1px 2px 2px rgba(0, 0, 0, 0.25));
}

.opt-toggle-btn-inactive {
  min-height: 55px;
  border: 0px;
  transition: all 0.05s ease-in-out;
  min-width: 100px;
  border-radius: 4px;
  &:hover {
    filter: brightness(85%);
  }
}

.opt-toggle-btn-active {
  padding: 4px 12px 4px 12px;
  margin: 0;
  border: 0px;
  border-radius: 4px;
  &:hover {
    filter: brightness(85%);
  }
}

.opt-toggle-btn-lyt {
  display: flex;
  height: 100%;
}

.opt-toggle-btn-selected {
  display: flex;
  flex-direction: row;
  gap: 18px;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}

.opt-toggle-btn-sep {
  min-width: 5px;
  margin: 3px 2px;
  border-radius: 4px;
}

.opt-toggle-btn-lbl {
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 0.9rem;
  font-weight: 400;
  align-items: center;
}

.opt-listitem-container {
  padding: 12px 8px 12px 8px;
  width: 100%;
  box-sizing: border-box;
}

/* =========================== END OPTION TOGGLE =========================== */

/* =========================== SCOPE SELECTOR ============================== */
.scope-selector {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.scope-selector-chk-container {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}


/* =========================== END SCOPE SELECTOR =========================== */

/* ========================== COLLECTION SELECTOR ========================== */
.collection-collapser-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
}
/* ======================== END COLLECTION SELECTOR ======================== */

/* ======================== COLLECTION BUILDER ============================= */
.collection-builder-layout {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 280px;
  width: calc(100% - 8px);
  max-width: 100%;
  margin: 4px;
  box-sizing: border-box;
  padding: 4px;
  overflow: hidden;
  border-radius: 4px;  
}

/* ========================= MENUS [user profile] ========================== */
.slot-container {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.slot-selector {
  display: flex;
  width: 100%;
  min-height: 40px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.user-profile-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-width: 650px;
}

.user-profile-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 12px 2px 12px 2px;
}

.user-profile-card-lyt-details {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 12;
  width: 100%;
}

.user-profile-qb-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.usr-prf-qb-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: center;
  width: 100%;
}

/* ================ MENUS [user profile - permission table] ================ */
.usr-prf-permset-lyt {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: center;
  width: 100%;
  gap: 12px;
}

.usr-prf-permset-type-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex: .65;
  padding: 12px;
  gap: 4px;
  border-radius: 3px;
}

.usr-prf-permset-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.usr-prf-perm-tooltip-lyt {
  display: 'flex';
  flex-direction: column;
  gap: 1;
  align-items: center;
  justify-content: center;
}

.usr-prf-perm-tooltip-lbl {
  width: '100%';
  display: flex;
  justify-content: center;
  align-items: center;
}

.usr-prf-permset-prj-lbl {
  display: flex;
  justify-content: start;
  /* padding-left: '4px'; */
  flex: 1;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/coreStyles.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,sBAAsB;AACxB;;AAEA,8EAA8E;;AAE9E,8EAA8E;AAC9E;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;;AAGA,+EAA+E;;AAE/E,8EAA8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA,8EAA8E;;AAE9E,8EAA8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,MAAM;EACN,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,OAAO;EACP,WAAW;AACb","sourcesContent":["/* ============================ OPTION TOGGLE ============================== */\n.opt-toggle-tag-container {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  width: 100%;\n}\n\n.opt-toggle-selected-type-display {\n  display: flex;\n  justify-content: flex-start;\n  font-size: 0.8rem;\n}\n\n.opt-toggle-tags {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 4px;\n}\n\n.opt-toggle-tag-selected {\n  display: flex;  \n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 8px 0 8px;\n  min-width: 20px;\n  max-width: 60px;\n  height: 25px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  align-items: center;\n  font-size: 0.9em;\n}\n\n.opt-toggle-tags-sep {\n  min-width: 2px;\n  margin: 3px 2px;\n  border-radius: 4px;\n}\n\n.opt-toggle-tag-text {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.opt-toggle-container {\n  display: flex;\n  height: 55px;\n  gap: 12px;\n  filter: drop-shadow(1px 2px 2px rgba(0, 0, 0, 0.25));\n}\n\n.opt-toggle-btn-inactive {\n  min-height: 55px;\n  border: 0px;\n  transition: all 0.05s ease-in-out;\n  min-width: 100px;\n  border-radius: 4px;\n  &:hover {\n    filter: brightness(85%);\n  }\n}\n\n.opt-toggle-btn-active {\n  padding: 4px 12px 4px 12px;\n  margin: 0;\n  border: 0px;\n  border-radius: 4px;\n  &:hover {\n    filter: brightness(85%);\n  }\n}\n\n.opt-toggle-btn-lyt {\n  display: flex;\n  height: 100%;\n}\n\n.opt-toggle-btn-selected {\n  display: flex;\n  flex-direction: row;\n  gap: 18px;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n}\n\n.opt-toggle-btn-sep {\n  min-width: 5px;\n  margin: 3px 2px;\n  border-radius: 4px;\n}\n\n.opt-toggle-btn-lbl {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  font-size: 0.9rem;\n  font-weight: 400;\n  align-items: center;\n}\n\n.opt-listitem-container {\n  padding: 12px 8px 12px 8px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* =========================== END OPTION TOGGLE =========================== */\n\n/* =========================== SCOPE SELECTOR ============================== */\n.scope-selector {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.scope-selector-chk-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n\n\n/* =========================== END SCOPE SELECTOR =========================== */\n\n/* ========================== COLLECTION SELECTOR ========================== */\n.collection-collapser-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px;\n}\n/* ======================== END COLLECTION SELECTOR ======================== */\n\n/* ======================== COLLECTION BUILDER ============================= */\n.collection-builder-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 280px;\n  width: calc(100% - 8px);\n  max-width: 100%;\n  margin: 4px;\n  box-sizing: border-box;\n  padding: 4px;\n  overflow: hidden;\n  border-radius: 4px;  \n}\n\n/* ========================= MENUS [user profile] ========================== */\n.slot-container {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n}\n\n.slot-selector {\n  display: flex;\n  width: 100%;\n  min-height: 40px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.user-profile-layout {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-width: 650px;\n}\n\n.user-profile-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: 12px 2px 12px 2px;\n}\n\n.user-profile-card-lyt-details {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  gap: 12;\n  width: 100%;\n}\n\n.user-profile-qb-layout {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.usr-prf-qb-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-self: center;\n  width: 100%;\n}\n\n/* ================ MENUS [user profile - permission table] ================ */\n.usr-prf-permset-lyt {\n  display: flex;\n  flex-direction: column;\n  justify-content: left;\n  align-items: center;\n  width: 100%;\n  gap: 12px;\n}\n\n.usr-prf-permset-type-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  flex: .65;\n  padding: 12px;\n  gap: 4px;\n  border-radius: 3px;\n}\n\n.usr-prf-permset-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.usr-prf-perm-tooltip-lyt {\n  display: 'flex';\n  flex-direction: column;\n  gap: 1;\n  align-items: center;\n  justify-content: center;\n}\n\n.usr-prf-perm-tooltip-lbl {\n  width: '100%';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.usr-prf-permset-prj-lbl {\n  display: flex;\n  justify-content: start;\n  /* padding-left: '4px'; */\n  flex: 1;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
